import React from "react";

import { graphql } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

import JsonLd from "../JsonLd";

const pixel = (value) =>
    value == null
        ? undefined
        : {
              "@type": "QuantitativeValue",
              value,
              unitCode: "E37",
          };

export const imageObjectJsonLD = ({
    src,
    alt = "",
    title,
    imageObject = {},
}) => {
    const original = src.childImageSharp?.original;
    const contentUrl = original?.src ?? src.publicURL;

    return {
        "@id": contentUrl,
        "@type": "ImageObject",
        contentUrl,
        datePublished: src.birthTime,
        dateModified: src.changeTime,
        width: pixel(original?.width),
        height: pixel(original?.height),
        caption: title,
        description: alt || undefined,
        ...imageObject,
    };
};

const Image = ({ src, alt = "", title, imageObject = {}, ...props }) => {
    const image = getImage(src);

    return (
        <>
            {image ? (
                <GatsbyImage {...{ image, alt, title, ...props }} />
            ) : (
                <img src={src.publicURL} {...{ alt, title, ...props }} />
            )}
            <JsonLd>
                {{
                    "@context": "https://schema.org/",
                    ...imageObjectJsonLD({ src, alt, title, imageObject }),
                }}
            </JsonLd>
        </>
    );
};
export default Image;

export const query = graphql`
    fragment ImageSrc on File {
        childImageSharp {
            original {
                height
                src
                width
            }
        }

        publicURL
        birthTime
        changeTime
        size
    }

    fragment Image on CMSImage {
        src {
            ...ImageSrc
        }
        alt
        title
        imageObject {
            caption
            description
        }
    }
`;
